'use client';
const IDENT_TAB_NAVIGATION = 'TabNavigation';
const defaultProps = {
    color: 'text.tertiary',
    activeColor: 'tabsnav.tabActive'
};

export { IDENT_TAB_NAVIGATION, defaultProps };
//# sourceMappingURL=TabNavigation.contract.js.map
